import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import CouponProp from '../../../challenges/propTypes/couponProp';

function JourneyStatsCoupon({ t, coupon }) {
  return (
    <div
      key={coupon.name + coupon.expirationDate}
      className="journey-overall-stats-awards-h-full"
    >
      <div className="journey-overall-stats-awards-item">
        <img
          src={
            coupon.image && coupon.image.thumb
              ? coupon.image.thumb
              : '/images/no_image_upload.png'
          }
          alt="course"
        />
        <div>
          <h6>{coupon.name}</h6>
          <p>
            <span className="course-subheader-item">
              <i className="la la-clock" />
              <span className="journey-overall-stats-awards-title">
                {`${t('rewards_activeUntil')}: `}
              </span>
              <span className="journey-overall-stats-awards-value">
                {moment.utc(coupon.expirationDate).format('DD MMM, YYYY')}
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

JourneyStatsCoupon.propTypes = {
  t: PropTypes.func.isRequired,
  coupon: PropTypes.shape(CouponProp.propType).isRequired,
};

export default translate(JourneyStatsCoupon);
